import { GlobalState } from '../../rootReducer';

export const selectCompanyGroupMembers = (state: GlobalState) => state.company.groupMembers;
export const selectGroupMembersMicro = (state: GlobalState) => state.company.groupMembersMicro;
export const selectIsCurrentCompanySettingsLoading = (state: GlobalState) => state.company.isCurrentCompanySettingsLoading;
export const selectCurrentCompanySettings = (state: GlobalState) => state.company.currentCompanySettings;
export const selectCurrentCompanyData = (state: GlobalState) => state.company.currentCompanyData;
